webpackJsonp([35783957827783],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Welcome'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Nicole Sharkey'
	      ),
	      ' is a licensed acupuncturist and Chinese medical practitioner in Seattle, WA. She provides acupuncture, herbal medicine and dietary advice for the treatment of a wide variety of conditions, including:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Chronic and acute pain, injury and trauma'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Men\u2019s and women\u2019s health concerns Stress, depression, and anxiety'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Gastrointestinal disorders Gynecological problems'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Immune disorders (chronic fatigue, candida, allergies, etc.)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Respiratory conditions Circulatory disorders Skin conditions'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Addiction recovery'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Immune system support as preventative medicine'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'and more.'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For a complete list of conditions treated by Chinese Medicine, click\xA0',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/acupuncture-treats' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Acupuncture and Chinese Herbal Medicine are part of a medical system that is over 2,000 years old and are based on the understanding that when in balance, the body has the capacity to heal itself. Through her Chinese medical practice, Nicole aims to help her patients discover their own healing potential and to find practical ways to achieve their health goals within their unique life experiences.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Nicole uses acupuncture, Chinese herbal medicine, nutritional therapy, Qi Gong (movement therapy), and Tui Na, (Chinese therapeutic massage). She use a wide array of techniques to best fit each patients, including the use of very gentle, and non-insertion acupuncture techniques for the needle-shy.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To schedule an appointment, a free 30-minute in person consultation, or for questions about how acupuncture and Chinese medicine can help you, please contact Nicole by phone: ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '(206) 335 -8017'
	      ),
	      ', or email:\xA0',
	      _react2.default.createElement(
	        'strong',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:sharkeyacupuncture@gmail.com' },
	          'sharkeyacupuncture@gmail.com'
	        )
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-56676fcd43cf765bf389.js